/**
 * lcp-atc.js — Add to cart for WMC pages when Laundry Cycle Pro/Ultra
 * is a separate product with fragrance variants.
 */
(function () {
  'use strict';

  var FREE_PACK_PROPERTY = { _lcp_free_pack: 'true' };

  function getCartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function getMainForm() {
    return document.querySelector('form.product-form--lcp-wmc');
  }

  function getLcpData() {
    return window.lcpProductData || null;
  }

  function isV3Offer() {
    var data = getLcpData();
    return !!(data && data.isV3Offer);
  }

  function isWmtLcpGiftOffer() {
    var data = getLcpData();
    return !!(data && data.isWmtLcpGiftOffer);
  }

  function getGiftRoot(form) {
    if (form) {
      var nested = form.querySelector('[data-wmt-lcp-gift]');
      if (nested) return nested;
    }
    return document.querySelector('[data-wmt-lcp-gift]');
  }

  function getGiftState(form) {
    var root = getGiftRoot(form);
    return {
      style: (root && root.getAttribute('data-style')) || 'pro',
      size: (root && root.getAttribute('data-size')) || 'p1',
      fragrance: (root && root.getAttribute('data-fragrance')) || ''
    };
  }

  function requireGiftFragrance(form) {
    if (typeof window.wmtLcpGiftRequireFragrance === 'function') {
      return window.wmtLcpGiftRequireFragrance(form);
    }
    return !!getGiftState(form).fragrance;
  }

  function buildWmtLcpGiftItems(form, includeGift) {
    var data = getLcpData();
    if (!data || !data.wmt) return null;
    var state = getGiftState(form);
    var wmtBucket = data.wmt[state.style];
    if (!wmtBucket) return null;
    var wmtId = state.size === 'p2' ? wmtBucket.twoPackVariantId : wmtBucket.onePackVariantId;
    if (!wmtId) return null;

    var items = [{ id: parseInt(wmtId, 10), quantity: 1 }];
    if (!includeGift) return items;
    if (!state.fragrance) return null;

    var giftBucket = data.gift && data.gift[state.style];
    if (!giftBucket) return null;
    var isFF = state.fragrance === 'free' || state.fragrance === 'fragrance-free';
    var packPrefix = state.size === 'p2' ? 'twoPack' : 'onePack';
    var giftId = isFF ? giftBucket[packPrefix + 'FfVariantId'] : giftBucket[packPrefix + 'FreshVariantId'];
    if (!giftId) return null;

    var giftItem = {
      id: parseInt(giftId, 10),
      quantity: 1,
      properties: {
        _auto_gift: 'true',
        _lcp_subscribe_gift: 'true',
        _hide_subscription_frequency: '1'
      }
    };
    var planId = isFF
      ? giftBucket[packPrefix + 'FfSellingPlanId']
      : giftBucket[packPrefix + 'FreshSellingPlanId'];
    planId = planId || giftBucket.sellingPlanId;
    if (planId) {
      giftItem.selling_plan = parseInt(planId, 10);
    }
    items.push(giftItem);
    return items;
  }

  function clearCart() {
    return fetch(getCartRoot() + 'cart/clear.js', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' }
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw data;
        return data;
      });
    });
  }

  function runWmtLcpGiftAtc(mainForm, atcBtn, includeGift) {
    if (lcpAtcInFlight) return;
    var withGift = includeGift !== false;
    if (withGift && !requireGiftFragrance(mainForm)) return;

    var items = buildWmtLcpGiftItems(mainForm, withGift);
    if (!items || !items.length) {
      alert('Could not add to cart. Please select a pack and fragrance, then try again.');
      return;
    }

    var hasGift = withGift && cartHasSnsGift(items);
    var giftLine = (items || []).filter(function (item) {
      return item.properties && item.properties._lcp_subscribe_gift === 'true';
    })[0];
    if (hasGift && (!giftLine || !giftLine.selling_plan)) {
      alert('Gift subscription is not available. Please try again.');
      return;
    }

    lcpAtcInFlight = true;
    setAtcButtonLoading(atcBtn, true);

    clearCart()
      .catch(function () {
        return null;
      })
      .then(function () {
        return postCartItems(items, { sections: !hasGift });
      })
      .then(function (data) {
        return maybeApplySnsGiftDiscount(items, data, Promise.resolve([]));
      })
      .then(function (data) {
        return handleCartSuccess(data, { applyGiftDiscount: hasGift });
      })
      .catch(function (err) {
        console.error('[LCP ATC]', err);
        alert(err.description || err.message || 'Could not add to cart. Please try again.');
      })
      .finally(function () {
        lcpAtcInFlight = false;
        setAtcButtonLoading(atcBtn, false);
      });
  }

  function isOtpOnlyOffer() {
    var data = getLcpData();
    return !!(data && data.isOtpOnlyOffer);
  }

  function isSubOnlyOffer() {
    var data = getLcpData();
    return !!(data && data.isSubOnlyOffer);
  }

  /**
   * Legacy flag — opt-in SnS AB replaced the passive 60-day flow.
   */
  function isPassiveSubOffer() {
    var data = getLcpData();
    return !!(data && data.isPassiveSubOffer);
  }

  /**
   * Opt-in Subscribe & Save AB (sub-v1/v2/v3): toggle controls whether a
   * selling plan is attached. LCP still adds as a single 4 Pack line.
   * Variant 3 also attaches a one-time free 1 Pack LCP/LCU gift.
   */
  function isOptinSnsOffer() {
    var data = getLcpData();
    return !!(data && data.isOptinSnsOffer);
  }

  function isOptinSubscribed() {
    var block = document.querySelector('.js-optin-sns-block');
    if (block) return block.getAttribute('aria-checked') === 'true';
    var toggle = document.getElementById('recurrent-toggle');
    return !!(toggle && toggle.checked);
  }

  function getDefaultLcpAtcMode() {
    var form = getMainForm();
    if (form && form.getAttribute('data-lcp-force-otp') === 'true') {
      form.removeAttribute('data-lcp-force-otp');
      return 'otp';
    }
    /* OTP-only (lcp-v2 / pricing AB): single discounted 4 Pack, like sub-v1 OTP. */
    if (isOtpOnlyOffer()) return 'otp';
    if (isOptinSnsOffer()) return isOptinSubscribed() ? 'subscription' : 'otp';
    return 'subscription';
  }

  function getSnsGiftVariantId(form) {
    var data = getLcpData();
    if (!data || data.snsIncentive !== 'gift') return null;
    var style = 'pro';
    var styleInput = form && form.querySelector('input[name="option1"]:checked');
    if (styleInput && String(styleInput.value || '').toLowerCase().indexOf('ultra') !== -1) {
      style = 'ultra';
    }
    return style === 'ultra' ? data.snsGiftUltraVariantId : data.snsGiftProVariantId;
  }

  function buildSnsGiftItem(form) {
    if (!isOptinSnsOffer() || !isOptinSubscribed()) return null;
    var giftId = getSnsGiftVariantId(form);
    if (!giftId) return null;
    var id = parseInt(giftId, 10);
    if (!id) return null;
    return {
      id: id,
      quantity: 1,
      properties: {
        _auto_gift: 'true',
        _lcp_subscribe_gift: 'true'
      }
    };
  }

  function appendSnsGiftItem(items, form) {
    var gift = buildSnsGiftItem(form);
    if (!gift) return items;
    var next = (items || []).slice();
    next.push(gift);
    return next;
  }

  function getVariantAllocationPlanId(variant) {
    if (!variant || !variant.selling_plan_allocations || !variant.selling_plan_allocations.length) {
      return null;
    }
    var allocs = variant.selling_plan_allocations;
    var hasName = false;
    var quietId = null;
    for (var i = 0; i < allocs.length; i++) {
      var name = ((allocs[i].selling_plan && allocs[i].selling_plan.name) || '').toLowerCase();
      if (name) hasName = true;
      if (
        name.indexOf('delivery') !== -1 ||
        name.indexOf('every') !== -1 ||
        name.indexOf('month') !== -1 ||
        name.indexOf('week') !== -1 ||
        name.indexOf('day') !== -1
      ) {
        continue;
      }
      var id = allocs[i].selling_plan_id || (allocs[i].selling_plan && allocs[i].selling_plan.id);
      if (id && name && !quietId) quietId = String(id);
    }
    if (hasName && quietId) return quietId;
    /* Storefront JSON omits plan names. Ghost cadence is first; quiet Recharge is last. */
    var pick = allocs[allocs.length - 1];
    if (pick.selling_plan_id) return String(pick.selling_plan_id);
    if (pick.selling_plan && pick.selling_plan.id) return String(pick.selling_plan.id);
    return quietId;
  }

  function getOptinLcpSellingPlanId(form) {
    var wrapper = getVisibleLcpWrapper(form);
    var planId = getActiveSellingPlanId(wrapper);
    if (planId) return planId;
    return getVariantAllocationPlanId(getExternalLcpVariant(form));
  }

  function isSellingPlanError(err) {
    var msg = ((err && (err.description || err.message)) || '').toLowerCase();
    return msg.indexOf('selling plan') !== -1;
  }

  function isUnavailableError(err) {
    var msg = ((err && (err.description || err.message)) || '').toLowerCase();
    return (
      msg.indexOf('sold out') !== -1 ||
      msg.indexOf('not available') !== -1 ||
      msg.indexOf('unavailable') !== -1 ||
      msg.indexOf('inventory') !== -1
    );
  }

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function getVisibleLcpWrapper(form) {
    if (!form) return null;

    var styleInput = form.querySelector('input[name="option1"]:checked');
    var style = styleInput ? (styleInput.value || '').toLowerCase().trim() : '';

    /* Prefer the checked LCP radio — visual "active" cards can desync from style. */
    var checked = form.querySelector(
      '.lcp-pill-wrapper:not(.lcp-pill-hidden)[data-external-lcp="true"] input.js-lcp-pill-option:checked'
    );
    if (checked) {
      var checkedWrapper = checked.closest('.lcp-pill-wrapper');
      if (checkedWrapper) return checkedWrapper;
    }

    if (style) {
      var styleWrapper = form.querySelector(
        '.lcp-pill-wrapper[data-lcp-style="' + style + '"]:not(.lcp-pill-hidden)[data-external-lcp="true"]'
      );
      if (styleWrapper) {
        var styleRadio = styleWrapper.querySelector('input.js-lcp-pill-option');
        if (styleRadio && styleRadio.checked) return styleWrapper;
      }
    }

    if (!form.getAttribute('data-lcp-external-variant-id')) return null;
    if (!style) return null;

    return form.querySelector(
      '.lcp-pill-wrapper[data-lcp-style="' + style + '"]:not(.lcp-pill-hidden)[data-external-lcp="true"]'
    );
  }

  function isHybridWipe(form) {
    form = form || getMainForm();
    return !!(form && form.querySelector('[data-lcp-hybrid-wipe]'));
  }

  function isFragStep(form) {
    form = form || getMainForm();
    return !!(form && form.querySelector('[data-lcp-015-frag-step]'));
  }

  function isHybridPotp(form) {
    form = form || getMainForm();
    return !!(form && form.querySelector('[data-lcp-hybrid-potp]'));
  }

  function getActiveFragranceBtn(wrapper) {
    if (!wrapper) return null;
    var style = wrapper.getAttribute('data-lcp-style');
    var scope = wrapper.closest('form') || document;
    if (style) {
      var selectors = [
        '[data-lcp-hybrid-opts] .lcp-fragrance-selector[data-lcp-style="' + style + '"]',
        '[data-lcp-015-frag-opts] .lcp-fragrance-selector[data-lcp-style="' + style + '"]'
      ];
      for (var i = 0; i < selectors.length; i++) {
        var pane = scope.querySelector(selectors[i]) || document.querySelector(selectors[i]);
        if (pane) return pane.querySelector('.lcp-fragrance-btn.active');
      }
    }
    return wrapper.querySelector('.lcp-fragrance-btn.active');
  }

  function isWrapperFragranceFree(wrapper) {
    if (!wrapper) return false;
    var activeBtn = getActiveFragranceBtn(wrapper);
    if (activeBtn) return activeBtn.getAttribute('data-fragrance') === 'fragrance-free';
    return wrapper.getAttribute('data-default-pack-key') === 'fragranceFree';
  }

  function selectLcpPillRadio(form, wrapper) {
    if (!form || !wrapper) return false;
    var radio = wrapper.querySelector('input.js-lcp-pill-option');
    if (!radio) return false;

    if (!radio.checked) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }

    form.querySelectorAll('.size-card').forEach(function (card) {
      var input = card.querySelector('input[type="radio"]');
      card.classList.toggle('active', !!(input && input.checked));
    });

    return true;
  }

  function isLcpSelected(form) {
    return !!getVisibleLcpWrapper(form || getMainForm());
  }

  function getSelectedStyle(form) {
    var styleInput = form.querySelector('input[name="option1"]:checked');
    return styleInput ? (styleInput.value || '').toLowerCase().trim() : '';
  }

  function getCheckedSizeInput(form) {
    var lcpPillInput = form.querySelector('.lcp-pill-wrapper input[type="radio"]');
    var sizeOptionName = lcpPillInput ? lcpPillInput.name : 'option2';
    return form.querySelector('input[name="' + sizeOptionName + '"]:checked');
  }

  function isWmtThreePackSelected(form) {
    var sizeInput = getCheckedSizeInput(form);
    if (!sizeInput || sizeInput.classList.contains('js-lcp-pill-option')) return false;
    return (sizeInput.value || '').toLowerCase().indexOf('3 pack') !== -1;
  }

  function getExternalLcpVariantId(form) {
    form = form || getMainForm();
    if (!form) return null;

    if (isHybridWipe(form) || isFragStep(form)) {
      var wipeWrapper = getVisibleLcpWrapper(form);
      var wipeBtn = getActiveFragranceBtn(wipeWrapper);
      return wipeBtn ? wipeBtn.getAttribute('data-variant-id') : null;
    }

    var attr = form.getAttribute('data-lcp-external-variant-id');
    if (attr) return attr;

    var wrapper = getVisibleLcpWrapper(form);
    if (!wrapper) return null;

    var activeBtn = getActiveFragranceBtn(wrapper);
    if (activeBtn) return activeBtn.getAttribute('data-variant-id');
    if (isWrapperFragranceFree(wrapper)) {
      var style = wrapper.getAttribute('data-lcp-style');
      var bucket = window.lcpProductData && window.lcpProductData[style];
      if (bucket && bucket.fragranceFreeVariantId) {
        return String(bucket.fragranceFreeVariantId);
      }
    }
    return wrapper.getAttribute('data-variant-id');
  }

  function getExternalLcpVariant(form) {
    form = form || getMainForm();
    var wrapper = getVisibleLcpWrapper(form);
    if (!wrapper) return null;

    var style = wrapper.getAttribute('data-lcp-style');
    var variantId = getExternalLcpVariantId(form);
    if (!variantId || !window.lcpProductData || !window.lcpProductData[style]) {
      return { id: variantId, available: true };
    }

    var bucket = window.lcpProductData[style];
    if (String(bucket.freshTideVariantId) === String(variantId)) return bucket.freshTide;
    if (String(bucket.fragranceFreeVariantId) === String(variantId)) return bucket.fragranceFree;
    if (String(bucket.otpFreshTideVariantId) === String(variantId)) return bucket.otpFreshTide;
    if (String(bucket.otpFragranceFreeVariantId) === String(variantId)) return bucket.otpFragranceFree;
    return { id: variantId, available: true };
  }

  function getFragrancePackKey(wrapper) {
    var btn = getActiveFragranceBtn(wrapper);
    if (btn) {
      var fragrance = btn.getAttribute('data-fragrance') || '';
      if (fragrance === 'fragrance-free') return 'fragranceFree';
      if (fragrance === 'fresh-coast') return 'freshCoast';
      return 'freshTide';
    }
    return wrapper.getAttribute('data-default-pack-key') || 'freshTide';
  }

  function getActiveSellingPlanId(wrapper) {
    var btn = getActiveFragranceBtn(wrapper);
    if (btn) {
      var btnPlanId = btn.getAttribute('data-selling-plan-id');
      if (btnPlanId) return btnPlanId;
    }
    if (wrapper) {
      var wrapperPlanId = wrapper.getAttribute('data-selling-plan-id');
      if (wrapperPlanId) return wrapperPlanId;
    }
    var style = wrapper ? wrapper.getAttribute('data-lcp-style') : '';
    var bucket = window.lcpProductData && style ? window.lcpProductData[style] : null;
    return bucket && bucket.sellingPlanId ? String(bucket.sellingPlanId) : null;
  }

  function getPackVariantIds(style, packKey) {
    var bucket = window.lcpProductData && window.lcpProductData[style];
    if (!bucket) return null;

    var map = {
      fragranceFree: {
        twoPackId: bucket.twoPackFragranceFreeVariantId,
        onePackId: bucket.onePackFragranceFreeVariantId,
        twoPackSellingPlanId: bucket.twoPackFragranceFreeSellingPlanId
      },
      freshCoast: {
        twoPackId: bucket.twoPackFreshCoastVariantId,
        onePackId: bucket.onePackFreshCoastVariantId,
        twoPackSellingPlanId: bucket.twoPackFreshCoastSellingPlanId
      },
      freshTide: {
        twoPackId: bucket.twoPackFreshTideVariantId,
        onePackId: bucket.onePackFreshTideVariantId,
        twoPackSellingPlanId: bucket.twoPackFreshTideSellingPlanId
      }
    };

    return map[packKey] || map.freshTide;
  }

  function canSplitPacks(packs) {
    return !!(packs && packs.twoPackId && packs.onePackId);
  }

  function isLcpPdpOfferPage() {
    return !!document.querySelector('[data-lcp-pdp-sub]');
  }

  function buildSingleSubscriptionItem(variantId, qty, sellingPlanId) {
    if (!variantId) return null;
    var item = { id: parseInt(variantId, 10), quantity: qty };
    if (sellingPlanId) {
      item.selling_plan = parseInt(sellingPlanId, 10);
    }
    if (isLcpPdpOfferPage()) {
      item.properties = { _hide_subscription_frequency: '1' };
    }
    return [item];
  }

  function getOtpVariant(form) {
    var wrapper = getVisibleLcpWrapper(form);
    if (!wrapper) return null;
    var style = wrapper.getAttribute('data-lcp-style');
    var bucket = window.lcpProductData && window.lcpProductData[style];
    if (!bucket) return null;
    var isFF = isWrapperFragranceFree(wrapper);
    return isFF ? (bucket.otpFragranceFree || bucket.otpFreshTide) : (bucket.otpFreshTide || bucket.otpFragranceFree);
  }

  function isFragranceFree(wrapper) {
    return isWrapperFragranceFree(wrapper);
  }

  function getQty(form) {
    var qtyInput = form.querySelector('[name="quantity"]');
    var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    return Number.isFinite(qty) && qty > 0 ? qty : 1;
  }

  function getVariantStrings() {
    return window.variantStrings || {
      addToCart: 'Add to cart',
      soldOut: 'Sold out',
      unavailable: 'Unavailable'
    };
  }

  function setAtcButtonLoading(btn, loading) {
    if (!btn) return;
    var textEl = btn.querySelector('.js-add-to-cart-text') || btn;
    if (loading) {
      if (!btn.hasAttribute('data-lcp-original-text')) {
        btn.setAttribute('data-lcp-original-text', textEl.textContent);
      }
      btn.disabled = true;
      textEl.textContent = 'Adding...';
    } else {
      btn.disabled = false;
      if (btn.hasAttribute('data-lcp-original-text')) {
        textEl.textContent = btn.getAttribute('data-lcp-original-text');
        btn.removeAttribute('data-lcp-original-text');
      }
    }
  }

  function isExternalLcpPurchasable(variant) {
    if (!variant || !variant.id) return false;
    if (variant.available !== false) return true;
    /* Shopify: continue selling when out of stock */
    if (variant.inventory_policy === 'continue') return true;
    /*
      Opt-in SnS backends (lcp/lcu-10-sub[-v2/-v3]) are often unlisted with
      0 tracked inventory. The pill still sells them as offer SKUs — do not
      hard-block ATC on available:false for those pages.
    */
    if (isOptinSnsOffer()) return true;
    if (isLcpPdpOfferPage()) return true;
    return false;
  }

  function updateAddToCartButtons(form, available) {
    var strings = getVariantStrings();
    form.querySelectorAll('.js-add-to-cart').forEach(function (btn) {
      var textEl = btn.querySelector('.js-add-to-cart-text') || btn;
      if (available) {
        btn.disabled = false;
        textEl.textContent = strings.addToCart;
        btn.classList.remove('klaviyo-bis-trigger');
      } else {
        btn.disabled = true;
        textEl.textContent = strings.soldOut;
      }
    });
  }

  function getMainProductData(form) {
    var el = form ? form.querySelector('.js-product-json') : null;
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function getCheckedWmtVariant(form) {
    var sizeInput = getCheckedSizeInput(form);
    if (!sizeInput || sizeInput.classList.contains('js-lcp-pill-option')) return null;

    if (isHybridPotp(form)) {
      var potpId = sizeInput.getAttribute('data-variant-id');
      if (!potpId) return null;
      return { id: parseInt(potpId, 10), available: true };
    }

    var productData = getMainProductData(form);
    if (!productData || !productData.variants) return null;

    var styleInput = form.querySelector('input[name="option1"]:checked');
    if (styleInput) {
      var byOpts = productData.variants.find(function (v) {
        return v.option1 === styleInput.value && v.option2 === sizeInput.value;
      });
      if (byOpts) return byOpts;
    }

    var variantId = sizeInput.getAttribute('data-variant-id');
    if (!variantId) return null;

    return (
      productData.variants.find(function (v) {
        return String(v.id) === String(variantId);
      }) || null
    );
  }

  /**
   * Passive sub offer: the OTP link follows the selected option.
   *   Buy 1 Pack of Washing Machine Cleaner Pro/Ultra for $24.99/$34.99
   *   Buy 2 Pack of Washing Machine Cleaner Pro/Ultra for $49.99/$69.99
   *   Buy 4 Pack of Laundry Cycle Pro/Ultra for $49.99/$69.99
   * Prices come straight from the one-time variant price.
   */
  function updatePassiveOtpLink(form, wrap, wrapper) {
    var packEl = wrap.querySelector('.js-lcp-otp-pack-label');
    var nameEl = wrap.querySelector('.js-lcp-otp-cycle-name');
    var priceEl = wrap.querySelector('.js-lcp-otp-price');

    if (wrapper) {
      var lcpVariant = getExternalLcpVariant(form);
      wrap.hidden = false;
      if (packEl) packEl.textContent = '4 Pack';
      if (nameEl) nameEl.textContent = wrapper.getAttribute('data-cycle-name') || 'Laundry Cycle Pro';
      if (priceEl && lcpVariant && lcpVariant.price != null) {
        priceEl.textContent = formatMoney(lcpVariant.price);
      }
      return;
    }

    var wmtVariant = getCheckedWmtVariant(form);
    if (!wmtVariant) {
      wrap.hidden = true;
      return;
    }

    var sizeInput = getCheckedSizeInput(form);
    var style = getSelectedStyle(form);
    wrap.hidden = false;
    if (packEl) packEl.textContent = sizeInput ? sizeInput.value : '1 Pack';
    if (nameEl) {
      nameEl.textContent = style === 'ultra' ? 'Washing Machine Cleaner Ultra' : 'Washing Machine Cleaner Pro';
    }
    if (priceEl && wmtVariant.price != null) {
      priceEl.textContent = formatMoney(wmtVariant.price);
    }
  }

  function updateOtpLink(form) {
    var wrap = document.querySelector('.js-lcp-otp-link-wrap');
    if (!wrap) return;

    var wrapper = getVisibleLcpWrapper(form);

    if (isPassiveSubOffer()) {
      updatePassiveOtpLink(form, wrap, wrapper);
      return;
    }

    wrap.hidden = !wrapper;

    if (!wrapper) return;

    var otpVariant = getOtpVariant(form);
    var priceEl = wrap.querySelector('.js-lcp-otp-price');
    var cycleEl = wrap.querySelector('.js-lcp-otp-cycle-name');
    if (cycleEl) {
      cycleEl.textContent = wrapper.getAttribute('data-cycle-name') || 'Laundry Cycle Pro';
    }
    if (priceEl && otpVariant && otpVariant.price != null) {
      priceEl.textContent = formatMoney(otpVariant.price);
    }
  }

  function syncLcpAtcState(form) {
    form = form || getMainForm();
    if (!form) return;

    var wrapper = getVisibleLcpWrapper(form);
    if (!wrapper) {
      form.removeAttribute('data-lcp-external-variant-id');
      form.removeAttribute('data-lcp-selling-plan-id');
      updateAddToCartButtons(form, true);
      updateOtpLink(form);
      if (window.lcpHybridSyncCta) window.lcpHybridSyncCta();
      if (window.lcp015FragSyncCta) window.lcp015FragSyncCta();
      return;
    }

    var variantId = getExternalLcpVariantId(form);
    if (variantId) {
      form.setAttribute('data-lcp-external-variant-id', variantId);
    } else if (isHybridWipe(form) || isFragStep(form)) {
      form.removeAttribute('data-lcp-external-variant-id');
    }

    var planId = getActiveSellingPlanId(wrapper);
    if (isOtpOnlyOffer()) {
      form.removeAttribute('data-lcp-selling-plan-id');
    } else if (isSubOnlyOffer() && planId) {
      form.setAttribute('data-lcp-selling-plan-id', planId);
    } else if (planId && wrapper.getAttribute('data-lcp-sns') !== 'false') {
      form.setAttribute('data-lcp-selling-plan-id', planId);
    } else {
      form.removeAttribute('data-lcp-selling-plan-id');
    }

    var variant = getExternalLcpVariant(form);
    var available = isExternalLcpPurchasable(variant);
    if ((isHybridWipe(form) || isFragStep(form)) && !getActiveFragranceBtn(wrapper)) available = true;
    updateAddToCartButtons(form, available);
    updateOtpLink(form);
    syncLcpGallery(form);
    if (window.lcpHybridSyncCta) window.lcpHybridSyncCta();
    if (window.lcp015FragSyncCta) window.lcp015FragSyncCta();
  }

  function getGalleryEl(form) {
    var scope =
      (form && form.closest('article.js-product')) ||
      document.querySelector('article.js-product');
    return scope ? scope.querySelector('.js-product-gallery') : null;
  }

  function getLcpGallerySlideIndex(gallery, style) {
    if (!gallery || !style) return -1;
    var slide = gallery.querySelector(
      '.product-gallery__slide--lcp[data-lcp-gallery-style="' + style + '"]'
    );
    if (!slide) return -1;
    var slidesContainer = gallery.querySelector('.js-fm-slider-slides');
    if (!slidesContainer) return -1;
    return Array.prototype.indexOf.call(slidesContainer.children, slide);
  }

  function slideGalleryToIndex(gallery, index) {
    if (!gallery || index < 0) return;

    if (gallery.id) {
      document.dispatchEvent(
        new CustomEvent('variantUpdate', {
          detail: {
            index: String(index),
            slideshowID: gallery.id
          }
        })
      );
      return;
    }

    var dots = gallery.querySelectorAll('.fm-slider__dot, .js-fm-slider-dot');
    if (dots[index]) dots[index].click();
  }

  function paintGallerySlide(slide, src, lockCombo) {
    if (!slide || !src) return;
    if (lockCombo) {
      slide.querySelectorAll('source').forEach(function (source) {
        source.removeAttribute('srcset');
        source.removeAttribute('data-srcset');
      });
    }
    slide.querySelectorAll('img').forEach(function (img) {
      if (lockCombo) img.removeAttribute('srcset');
      img.src = src;
      if (img.hasAttribute('data-original-image') || lockCombo) {
        img.setAttribute('data-original-image', src);
      }
    });
  }

  function updateLcpGallerySlideImage(gallery, style, variant) {
    if (!gallery || !style) return;

    var slide = gallery.querySelector(
      '.product-gallery__slide--lcp[data-lcp-gallery-style="' + style + '"]'
    );
    if (!slide) return;

    var comboSrc = slide.getAttribute('data-lcp-combo-src');
    if (comboSrc) {
      paintGallerySlide(slide, comboSrc, true);
      return;
    }

    if (!variant) return;
    var image = variant.featured_image || variant.featured_media;
    var src = image && (image.src || (image.preview_image && image.preview_image.src));
    if (!src) return;
    paintGallerySlide(slide, src, false);
  }

  function syncLcpGallery(form) {
    form = form || getMainForm();
    if (!form) return;

    var wrapper = getVisibleLcpWrapper(form);
    if (!wrapper) return;

    var gallery = getGalleryEl(form);
    if (!gallery) return;

    var style = wrapper.getAttribute('data-lcp-style');
    var variant = getExternalLcpVariant(form);
    if (variant) {
      updateLcpGallerySlideImage(gallery, style, variant);
    }

    var slideIndex = getLcpGallerySlideIndex(gallery, style);
    if (slideIndex >= 0) {
      slideGalleryToIndex(gallery, slideIndex);
    }
  }

  var lcpAtcInFlight = false;

  var CART_SECTION_ELEMENT_IDS = ['ajaxCartContent', 'ajaxCartBtn', 'cartContent'];

  function getCartSectionIds() {
    var ids = [];
    CART_SECTION_ELEMENT_IDS.forEach(function (elementId) {
      var el = document.getElementById(elementId);
      if (!el) return;
      var section = el.closest('.shopify-section');
      if (section) ids.push(section.id.replace('shopify-section-', ''));
    });
    return ids.filter(function (value, index, array) {
      return array.indexOf(value) === index;
    });
  }

  function announceCartAdded() {
    var status = document.getElementById('screenReaderStatus');
    if (status && window.cartStrings && window.cartStrings.added) {
      status.textContent = '';
      status.textContent = window.cartStrings.added;
    }
  }

  function refreshAndOpenCartFallback() {
    var ajaxCartContent = document.getElementById('ajaxCartContent');
    var ajaxCartBtn = document.getElementById('ajaxCartBtn');
    if (!ajaxCartContent && !ajaxCartBtn) {
      if (window.EventBus) window.EventBus.emit('cart:show');
      return Promise.resolve();
    }

    var sectionIds = getCartSectionIds();
    if (sectionIds.length === 0) {
      if (window.EventBus) window.EventBus.emit('cart:show');
      return Promise.resolve();
    }

    return Promise.all(
      sectionIds.map(function (sectionId) {
        return fetch(window.location.pathname + '?section_id=' + sectionId, { credentials: 'same-origin' })
          .then(function (res) { return res.ok ? res.text() : null; })
          .then(function (html) { return { sectionId: sectionId, html: html }; });
      })
    ).then(function (results) {
      results.forEach(function (result) {
        if (!result.html) return;
        var doc = new DOMParser().parseFromString(result.html, 'text/html');
        var newContent = doc.querySelector('#ajaxCartContent');
        if (newContent && ajaxCartContent) {
          ajaxCartContent.innerHTML = newContent.innerHTML;
        }
        var newBtn = doc.querySelector('#ajaxCartBtn');
        if (newBtn && ajaxCartBtn) {
          ajaxCartBtn.innerHTML = newBtn.innerHTML;
        }
        var newCartContent = doc.querySelector('#cartContent');
        var currentCartContent = document.getElementById('cartContent');
        if (newCartContent && currentCartContent) {
          currentCartContent.innerHTML = newCartContent.innerHTML;
        }
      });

      if (window.EventBus) {
        window.EventBus.emit('cart:show');
        window.EventBus.emit('cart:updated');
        window.EventBus.emit('cart:markup:updated');
        window.EventBus.emit('content:changed');
      }
    }).catch(function () {
      if (window.EventBus) window.EventBus.emit('cart:show');
    });
  }

  var WMT_OFFER_STRIP_GIFT_IDS = {
    '44601685803164': true,
    '45830666846364': true
  };

  function stripWmtOfferStoreGifts(data) {
    return fetch(getCartRoot() + 'cart.js', {
      credentials: 'include',
      headers: { Accept: 'application/json' }
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        var updates = {};
        (cart.items || []).forEach(function (item) {
          if (WMT_OFFER_STRIP_GIFT_IDS[String(item.variant_id)]) {
            updates[item.key] = 0;
          }
        });
        if (!Object.keys(updates).length) return data;
        var payload = { updates: updates };
        var sectionIds = getCartSectionIds();
        if (sectionIds.length) payload.sections = sectionIds;
        return fetch(getCartRoot() + 'cart/update.js', {
          method: 'POST',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        }).then(function (res) {
          return res.json().then(function (updateData) {
            if (!res.ok) return data;
            if (updateData && updateData.sections) {
              data = data || {};
              data.sections = updateData.sections;
            }
            return data;
          });
        });
      })
      .catch(function () {
        return data;
      });
  }

  function bindWmtOfferCartCheckout() {
    if (window.__wmtOfferCheckoutBound) return;
    if (!isWmtLcpGiftOffer()) return;
    if (getLcpData() && getLcpData().skipCartDrawer !== false) return;
    window.__wmtOfferCheckoutBound = true;
    document.addEventListener(
      'submit',
      function (e) {
        var form = e.target;
        if (!form || !form.classList || !form.classList.contains('ajax-cart__checkout')) return;
        if (form.getAttribute('data-wmt-stripped') === 'true') return;
        e.preventDefault();
        e.stopPropagation();
        stripWmtOfferStoreGifts({}).then(function () {
          form.setAttribute('data-wmt-stripped', 'true');
          HTMLFormElement.prototype.submit.call(form);
        });
      },
      true
    );
  }

  function handleCartSuccess(data, opts) {
    opts = opts || {};
    if (isWmtLcpGiftOffer()) {
      document.cookie = 'discount_code=; Path=/; Max-Age=0';
      document.cookie = 'discount_code=; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 GMT';
      var skipDrawer = !getLcpData() || getLcpData().skipCartDrawer !== false;
      var giftCode = opts.applyGiftDiscount && getSnsGiftDiscountCode();
      if (!skipDrawer) {
        return stripWmtOfferStoreGifts(data).then(function (next) {
          announceCartAdded();
          var shown;
          if (next && next.sections && Object.keys(next.sections).length && window.EventBus) {
            window.EventBus.emit('cart:updated', next);
            window.EventBus.emit('cart:show');
            shown = Promise.resolve();
          } else {
            shown = refreshAndOpenCartFallback();
          }
          return shown.then(function () {
            return new Promise(function (resolve) {
              setTimeout(resolve, 800);
            });
          }).then(function () {
            return stripWmtOfferStoreGifts({});
          });
        });
      }
      if (giftCode) {
        window.location.href =
          getCartRoot() +
          'discount/' +
          encodeURIComponent(giftCode) +
          '?redirect=' +
          encodeURIComponent('/checkout');
        return Promise.resolve();
      }
      window.location.href = getCartRoot() + 'checkout';
      return Promise.resolve();
    }

    if (window.theme && window.theme.settings && window.theme.settings.cart_type === 'page') {
      window.location.href = getCartRoot() + 'cart';
      return Promise.resolve();
    }

    announceCartAdded();

    if (data && data.sections && Object.keys(data.sections).length && window.EventBus) {
      window.EventBus.emit('cart:updated', data);
      window.EventBus.emit('cart:show');
      return Promise.resolve();
    }

    return refreshAndOpenCartFallback();
  }

  function postCartItems(items, opts) {
    opts = opts || {};
    var payload = { items: items };
    /* sections: false → skip bundled section rendering; used when another
       request follows in the same ATC chain and will render them instead. */
    if (opts.sections !== false) {
      var sectionIds = getCartSectionIds();
      if (sectionIds.length) {
        payload.sections = sectionIds;
      }
    }

    return fetch(getCartRoot() + 'cart/add.js', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw data;
        return data;
      });
    });
  }

  function getApplicableDiscountCodes(cart) {
    if (!cart || !cart.discount_codes || !cart.discount_codes.length) return [];
    return cart.discount_codes
      .filter(function (entry) {
        return entry && entry.applicable && entry.code;
      })
      .map(function (entry) {
        return entry.code;
      });
  }

  /*
    Reads the cart's currently applicable discount codes. Never rejects —
    resolves null when the read fails, so it can be started in parallel with
    an add without risking an unhandled rejection.
  */
  function getCartDiscountCodes() {
    return fetch(getCartRoot() + 'cart.js', {
      credentials: 'include',
      headers: { Accept: 'application/json' }
    })
      .then(function (res) {
        return res.json();
      })
      .then(getApplicableDiscountCodes)
      .catch(function () {
        return null;
      });
  }

  function applyCartDiscountCode(code, codesPromise) {
    if (!code) return Promise.resolve(null);

    return (codesPromise || getCartDiscountCodes()).then(function (codes) {
      if (codes === null) {
        throw new Error('Could not read cart discount codes');
      }
      if (isWmtLcpGiftOffer()) {
        codes = [];
      }
      /* Already applied — discounts re-evaluate on cart changes, skip the update. */
      if (codes.indexOf(code) !== -1) return null;
      codes = codes.slice();
      codes.push(code);

      var payload = { discount: codes.join(',') };
      var sectionIds = getCartSectionIds();
      if (sectionIds.length) payload.sections = sectionIds;

      return fetch(getCartRoot() + 'cart/update.js', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw data;
          return data;
        });
      });
    });
  }

  function isSplitCartItems(items) {
    return !!(items && items.length > 1 && items.some(function (item) {
      return item.properties && item.properties._lcp_free_pack === 'true';
    }));
  }

  function cartHasSnsGift(items) {
    return !!(items && items.some(function (item) {
      return item.properties && item.properties._lcp_subscribe_gift === 'true';
    }));
  }

  var SPLIT_DISCOUNT_FALLBACKS = {
    wmt: 'WMT-B2G1-FREE',
    lcp: 'LCP-B2G2-FREE',
    lcu: 'LCU-B2G2-FREE',
    lcpOtp: 'LCP-B2G1-OTP-FREE',
    lcuOtp: 'LCU-B2G1-OTP-FREE'
  };

  var SNS_GIFT_DISCOUNT_FALLBACK = 'SNS-LCP-GIFT-FREE';

  function getSnsGiftDiscountCode() {
    var data = getLcpData() || {};
    return data.snsGiftDiscountCode || SNS_GIFT_DISCOUNT_FALLBACK;
  }

  function maybeApplySnsGiftDiscount(items, data, codesPromise) {
    if (!cartHasSnsGift(items)) return Promise.resolve(data);

    var code = getSnsGiftDiscountCode();
    if (!code) return Promise.resolve(data);

    return applyCartDiscountCode(code, codesPromise)
      .then(function (updateData) {
        if (!updateData) return data;
        if (updateData.sections) data.sections = updateData.sections;
        if (updateData.items) data.items = updateData.items;
        if (typeof updateData.total_price === 'number') data.total_price = updateData.total_price;
        if (!isDiscountCodeApplicable(updateData, code)) {
          if (isWmtLcpGiftOffer()) {
            throw {
              message: 'The free gift could not be applied. Please try again.'
            };
          }
          console.warn('[LCP ATC] SNS gift discount code was not applicable:', code, updateData);
        }
        return data;
      })
      .catch(function (err) {
        if (isWmtLcpGiftOffer()) throw err;
        console.warn('[LCP ATC] Could not apply SNS gift discount code:', err);
        return data;
      });
  }

  function getSplitDiscountCode(kind, form, mode) {
    var data = getLcpData() || {};

    if (is015SplitOffer() && kind === 'lcp') {
      if (mode === 'otp' && data.otpIsB2G1) return 'WMT2-LCP1-FREE-015';
      /* Refill plan is full price; this code makes its first payment $0. */
      if (get015RefillPlanId(form, mode)) return 'WMT2-LCP2-REFILL-015';
      return 'WMT2-LCP2-FREE-015';
    }

    if (kind === 'wmt') {
      return data.wmtFreePackDiscountCode || SPLIT_DISCOUNT_FALLBACKS.wmt;
    }

    // sub-only / legacy otp-b2g2: pick free-pack code by Pro vs Ultra product
    if (isOtpOnlyOffer() || isSubOnlyOffer()) {
      var offerStyle = form ? getSelectedStyle(form) : '';
      if (offerStyle === 'ultra') {
        return data.lcuFreePackDiscountCode || data.lcpFreePackDiscountCode || SPLIT_DISCOUNT_FALLBACKS.lcu;
      }
      return data.lcpFreePackDiscountCode || SPLIT_DISCOUNT_FALLBACKS.lcp;
    }

    var style = form ? getSelectedStyle(form) : '';
    var isOtp = mode === 'otp';

    if (style === 'ultra') {
      if (isOtp) {
        return data.lcuOtpFreePackDiscountCode || SPLIT_DISCOUNT_FALLBACKS.lcuOtp;
      }
      return data.lcuFreePackDiscountCode || data.lcpFreePackDiscountCode || SPLIT_DISCOUNT_FALLBACKS.lcu;
    }

    if (isOtp) {
      return data.lcpOtpFreePackDiscountCode || SPLIT_DISCOUNT_FALLBACKS.lcpOtp;
    }

    return data.lcpFreePackDiscountCode || SPLIT_DISCOUNT_FALLBACKS.lcp;
  }

  function isDiscountCodeApplicable(updateData, code) {
    if (!updateData || !updateData.discount_codes || !code) return false;
    var target = code.toUpperCase();
    return updateData.discount_codes.some(function (entry) {
      return entry && entry.code && entry.code.toUpperCase() === target && entry.applicable;
    });
  }

  function shouldApplySingleOtpDiscount(mode) {
    if (mode !== 'otp') return false;
    var data = getLcpData();
    return !!(data && data.applySingleOtpDiscount);
  }

  function postSplitCartItems(items, discountKind, form, mode, opts) {
    return postCartItems(items, opts).then(function (data) {
      if (!isSplitCartItems(items) && !shouldApplySingleOtpDiscount(mode)) return data;

      var code = getSplitDiscountCode(discountKind, form, mode);
      if (!code) return data;

      return applyCartDiscountCode(code)
        .then(function (updateData) {
          if (updateData && updateData.sections) {
            data.sections = updateData.sections;
          }
          if (updateData && updateData.items) {
            data.items = updateData.items;
          }
          if (updateData && typeof updateData.total_price === 'number') {
            data.total_price = updateData.total_price;
          }
          if (updateData && !isDiscountCodeApplicable(updateData, code)) {
            console.warn('[LCP ATC] Free-pack discount code was not applicable:', code, updateData);
          }
          return data;
        })
        .catch(function (err) {
          console.warn('[LCP ATC] Could not apply free-pack discount code:', err);
          return data;
        });
    });
  }

  function buildSplitItems(twoPackId, onePackId, qty, options) {
    options = options || {};
    if (!twoPackId || !onePackId) return null;

    var freeCount = options.freeCount || 1;
    var items = [
      {
        id: parseInt(twoPackId, 10),
        quantity: qty
      }
    ];

    for (var i = 0; i < freeCount; i++) {
      items.push({
        id: parseInt(onePackId, 10),
        quantity: qty,
        properties: Object.assign({}, FREE_PACK_PROPERTY, { _lcp_free_index: String(i + 1) })
      });
    }

    if (options.sellingPlanId) {
      items[0].selling_plan = parseInt(options.sellingPlanId, 10);
    }

    return items;
  }

  function buildLcpSplitItems(packs, qty, options) {
    if (!packs || !packs.twoPackId || !packs.onePackId) return null;
    options = options || {};
    return buildSplitItems(packs.twoPackId, packs.onePackId, qty, options);
  }

  // Buy 2 Get 2 Free: add the free pack as a single 2-pack line item
  // rather than two individual 1-pack line items.
  function buildLcpB2G2Items(packs, qty, sellingPlanId) {
    if (!packs || !packs.twoPackId) return null;

    var items = [
      { id: parseInt(packs.twoPackId, 10), quantity: qty },
      {
        id: parseInt(packs.twoPackId, 10),
        quantity: qty,
        properties: Object.assign({}, FREE_PACK_PROPERTY)
      }
    ];

    if (sellingPlanId) {
      items[0].selling_plan = parseInt(sellingPlanId, 10);
    }

    return items;
  }

  function usesLcpB2G2SplitCart() {
    return isV3Offer() || isSubOnlyOffer();
  }

  function buildLcpB2G2FromPacks(packs, qty, withSubscription) {
    if (!packs || !packs.twoPackId) return null;
    var planId = withSubscription ? packs.twoPackSellingPlanId : null;
    return buildLcpB2G2Items(packs, qty, planId);
  }

  function is015SplitOffer() {
    var data = getLcpData();
    return !!(data && data.is015Split);
  }

  /* V2/V4 (otpIsB2G1) outside Buy Once: Recharge 30-day refill plan, first one free. */
  function get015RefillPlanId(form, mode) {
    var data = getLcpData();
    if (!form || mode === 'otp' || !data || !data.otpIsB2G1) return null;
    var style = getSelectedStyle(form);
    if (style !== 'pro' && style !== 'ultra') style = 'pro';
    var packs = getPackVariantIds(style, getFragrancePackKey(getVisibleLcpWrapper(form)));
    var planId = packs && parseInt(packs.twoPackSellingPlanId, 10);
    return planId || null;
  }

  function build015WmtLcpItems(form, mode) {
    var data = getLcpData();
    if (!data || !data.wmc) return null;

    var style = getSelectedStyle(form);
    if (style !== 'pro' && style !== 'ultra') style = 'pro';
    var wmtBucket = data.wmc[style];
    var wrapper = getVisibleLcpWrapper(form);
    var packKey = getFragrancePackKey(wrapper);
    var packs = getPackVariantIds(style, packKey);
    var qty = getQty(form);
    if (!wmtBucket || !wmtBucket.twoPackVariantId || !packs) return null;

    var b2g1 = mode === 'otp' && data.otpIsB2G1;
    var lcpId = b2g1 ? packs.onePackId : packs.twoPackId;
    if (!lcpId) return null;

    var lcpItem = {
      id: parseInt(lcpId, 10),
      quantity: qty,
      properties: Object.assign({ _hide_subscription_frequency: '1' }, FREE_PACK_PROPERTY)
    };

    var refillPlanId = get015RefillPlanId(form, mode);
    if (refillPlanId) lcpItem.selling_plan = refillPlanId;

    return [
      { id: parseInt(wmtBucket.twoPackVariantId, 10), quantity: qty },
      lcpItem
    ];
  }

  function buildLcpCartItems(form, mode, options) {
    options = options || {};
    var includeGift = options.includeGift !== false;
    var wrapper = getVisibleLcpWrapper(form);
    if (!wrapper) return null;

    var qty = getQty(form);
    var style = wrapper.getAttribute('data-lcp-style');
    var packKey = getFragrancePackKey(wrapper);
    var snsVariantId = getExternalLcpVariantId(form);
    var activePlanId = isOptinSnsOffer()
      ? getOptinLcpSellingPlanId(form)
      : getActiveSellingPlanId(wrapper);
    if (options.forcePlanId !== undefined) activePlanId = options.forcePlanId;
    var packs = getPackVariantIds(style, packKey);
    var items = null;

    if (is015SplitOffer()) {
      var split015 = build015WmtLcpItems(form, mode);
      if (!split015) return null;
      return split015;
    }

    if (mode === 'otp-b2g2') {
      var otpB2g2Split = buildLcpB2G2FromPacks(packs, qty, false);
      if (otpB2g2Split) return otpB2g2Split;

      var otpB2g2Fallback = getOtpVariant(form);
      var otpB2g2FallbackId = otpB2g2Fallback && otpB2g2Fallback.id ? otpB2g2Fallback.id : snsVariantId;
      if (!otpB2g2FallbackId) return null;
      return buildSingleSubscriptionItem(otpB2g2FallbackId, qty, null);
    }

    if (mode === 'otp') {
      if (isHybridPotp(form)) {
        if (!snsVariantId) return null;
        return buildSingleSubscriptionItem(snsVariantId, qty, null);
      }

      if (isV3Offer()) {
        if (canSplitPacks(packs)) {
          return buildLcpSplitItems(packs, qty, { freeCount: 1 });
        }
        var v3OtpVariant = getOtpVariant(form);
        if (v3OtpVariant && v3OtpVariant.id) {
          return [{ id: parseInt(v3OtpVariant.id, 10), quantity: qty }];
        }
        return null;
      }

      /* Opt-in SnS OFF / OTP-only: single discounted 4 Pack, no selling plan */
      if (isOptinSnsOffer() || isOtpOnlyOffer()) {
        if (!snsVariantId) return null;
        return buildSingleSubscriptionItem(snsVariantId, qty, null);
      }

      var passiveOtp = getOtpVariant(form);
      var passiveOtpId = passiveOtp && passiveOtp.id ? passiveOtp.id : snsVariantId;
      if (!passiveOtpId) return null;
      return buildSingleSubscriptionItem(passiveOtpId, qty, null);
    }

    if (isSubOnlyOffer() || isV3Offer()) {
      var subSplit = buildLcpB2G2FromPacks(packs, qty, true);
      if (subSplit) return includeGift ? appendSnsGiftItem(subSplit, form) : subSplit;
      items = buildSingleSubscriptionItem(snsVariantId, qty, activePlanId);
      return includeGift ? appendSnsGiftItem(items, form) : items;
    }

    /* Opt-in SnS ON: single 4 Pack line (+ free gift line on sub-v3). */
    if (isOptinSnsOffer()) {
      if (!snsVariantId) return null;
      items = buildSingleSubscriptionItem(snsVariantId, qty, activePlanId);
      return includeGift ? appendSnsGiftItem(items, form) : items;
    }

    items = buildSingleSubscriptionItem(snsVariantId, qty, activePlanId);
    return includeGift ? appendSnsGiftItem(items, form) : items;
  }

  function buildWmtCartItems(form) {
    var data = getLcpData();
    if (!data || !data.wmc) return null;

    var style = getSelectedStyle(form);
    var bucket = data.wmc[style];
    if (!bucket || !bucket.twoPackVariantId || !bucket.onePackVariantId) return null;

    return buildSplitItems(bucket.twoPackVariantId, bucket.onePackVariantId, getQty(form), { freeCount: 1 });
  }

  function fragStepNeedsChoice(form) {
    form = form || getMainForm();
    if (!isFragStep(form) || !isLcpSelected(form)) return false;
    return !getActiveFragranceBtn(getVisibleLcpWrapper(form));
  }

  function runLcpAtc(mainForm, atcBtn, mode) {
    if (fragStepNeedsChoice(mainForm)) return;
    if (lcpAtcInFlight) return;
    lcpAtcInFlight = true;
    setAtcButtonLoading(atcBtn, true);

    addLcpToCart(mainForm, mode)
      .then(function (data) {
        if (window.lcpHybridAfterAdd) window.lcpHybridAfterAdd();
        if (window.lcp015FragAfterAdd) window.lcp015FragAfterAdd();
        return handleCartSuccess(data);
      })
      .catch(function (err) {
        console.error('[LCP ATC]', err);
        var msg = err && (err.description || err.message);
        if (!msg && isUnavailableError(err)) {
          msg = 'This Laundry Cycle pack is unavailable. Check inventory on the LCP backend product.';
        }
        alert(msg || 'Could not add to cart. Please try again.');
      })
      .finally(function () {
        lcpAtcInFlight = false;
        /* Restore the clicked button first — it may live outside mainForm
           (sticky bar), which syncLcpAtcState does not touch. */
        setAtcButtonLoading(atcBtn, false);
        syncLcpAtcState(mainForm);
      });
  }

  function isLcpPdpWmtOtp() {
    var root = document.querySelector('[data-lcp-pdp-sub]');
    return !!(root && root.getAttribute('data-lcp-packs-only') === 'true');
  }

  /* V3 WMT (and V1): add the selected style+size with that variant's own plan.
     Do not reuse a Pro data-sub-plan-id on Ultra — those IDs differ and Shopify
     rejects the add, which opens an empty cart drawer. */
  function runLcpPdpWmtAtc(mainForm, atcBtn) {
    if (lcpAtcInFlight) return;

    var variant = getCheckedWmtVariant(mainForm);
    if (!variant || !variant.id) {
      console.error('[LCP ATC] No WMT variant selected');
      return;
    }

    var planInput = mainForm.querySelector('input[name="selling_plan"]');
    var forceWmtOtp = mainForm.getAttribute('data-lcp-force-wmt-otp') === 'true';
    if (forceWmtOtp) mainForm.removeAttribute('data-lcp-force-wmt-otp');
    var otp = forceWmtOtp || isLcpPdpWmtOtp() || (planInput && planInput.disabled);
    var sizeInput = mainForm.querySelector(
      '.product-options__size input.js-product-option:checked:not(.js-lcp-pill-option)'
    );
    var planId = null;
    if (!otp) {
      if (isHybridPotp(mainForm) && sizeInput && sizeInput.getAttribute('data-sub-plan-id')) {
        planId = sizeInput.getAttribute('data-sub-plan-id');
      } else {
        planId = getVariantAllocationPlanId(variant);
        if (!planId && sizeInput) planId = sizeInput.getAttribute('data-sub-plan-id');
      }
    }

    var idInput = mainForm.querySelector('input[name="id"]');
    if (idInput) idInput.value = variant.id;
    if (sizeInput) {
      sizeInput.setAttribute('data-variant-id', variant.id);
      if (planId) sizeInput.setAttribute('data-sub-plan-id', planId);
    }
    if (planInput && planId && !planInput.disabled) planInput.value = planId;

    var item = {
      id: parseInt(variant.id, 10),
      quantity: getQty(mainForm),
      properties: { _hide_subscription_frequency: '1' }
    };
    if (planId) item.selling_plan = parseInt(planId, 10);

    lcpAtcInFlight = true;
    setAtcButtonLoading(atcBtn, true);

    postCartItems([item])
      .catch(function (err) {
        if (item.selling_plan && isSellingPlanError(err)) {
          delete item.selling_plan;
          return postCartItems([item]);
        }
        throw err;
      })
      .then(function (data) {
        return handleCartSuccess(data);
      })
      .catch(function (err) {
        console.error('[LCP ATC]', err);
        alert(err.description || err.message || 'Could not add to cart. Please try again.');
      })
      .finally(function () {
        lcpAtcInFlight = false;
        setAtcButtonLoading(atcBtn, false);
        syncLcpAtcState(mainForm);
      });
  }

  /* Passive sub offer: OTP link with a WMT pack selected — add the checked
     WMT variant once, with no selling plan. */
  function runWmtOtpAtc(mainForm) {
    if (lcpAtcInFlight) return;

    var variant = getCheckedWmtVariant(mainForm);
    if (!variant) return;

    lcpAtcInFlight = true;
    postCartItems([{ id: parseInt(variant.id, 10), quantity: getQty(mainForm) }])
      .then(function (data) {
        return handleCartSuccess(data);
      })
      .catch(function (err) {
        console.error('[LCP ATC]', err);
        alert(err.description || err.message || 'Could not add to cart. Please try again.');
      })
      .finally(function () {
        lcpAtcInFlight = false;
        syncLcpAtcState(mainForm);
      });
  }

  function runWmtSplitAtc(mainForm, atcBtn) {
    if (lcpAtcInFlight) return;
    lcpAtcInFlight = true;
    setAtcButtonLoading(atcBtn, true);

    var items = buildWmtCartItems(mainForm);
    if (!items) {
      lcpAtcInFlight = false;
      setAtcButtonLoading(atcBtn, false);
      return Promise.resolve();
    }

    return postSplitCartItems(items, 'wmt', mainForm)
      .then(function (data) {
        return handleCartSuccess(data);
      })
      .catch(function (err) {
        console.error('[LCP ATC]', err);
        alert(err.description || err.message || 'Could not add to cart. Please try again.');
      })
      .finally(function () {
        lcpAtcInFlight = false;
        setAtcButtonLoading(atcBtn, false);
        syncLcpAtcState(mainForm);
      });
  }

  function addLcpToCart(form, mode) {
    mode = mode || 'subscription';

    if (!isLcpSelected(form)) {
      if (isV3Offer() && isWmtThreePackSelected(form)) {
        var wmtItems = buildWmtCartItems(form);
        if (wmtItems) return postSplitCartItems(wmtItems, 'wmt', form);
      }
      return Promise.reject(new Error('No LCP variant selected'));
    }

    /* Gift (sub-v3) goes in the same add.js call — one round trip. */
    var items = buildLcpCartItems(form, mode);
    if (!items || !items.length) {
      return Promise.reject(new Error('No LCP variant selected'));
    }

    var hasGift = cartHasSnsGift(items);
    /* Overlap the discount pre-read with the add — adds don't change codes. */
    var codesPromise = hasGift ? getCartDiscountCodes() : null;

    function afterMainAdd(addedItems) {
      return function (data) {
        return maybeApplySnsGiftDiscount(addedItems, data, codesPromise);
      };
    }

    /* When a discount update follows, let IT render the cart sections. */
    return postSplitCartItems(items, 'lcp', form, mode, { sections: !hasGift })
      .then(afterMainAdd(items))
      .catch(function (err) {
        var planError = isSellingPlanError(err);

        /* Opt-in: retry without selling plan if Recharge plan is missing/mismatched.
           No subscription → no subscribe gift either. */
        if (isOptinSnsOffer() && mode === 'subscription' && planError) {
          var otpItems = buildLcpCartItems(form, 'otp', { includeGift: false });
          if (!otpItems || !otpItems.length) throw err;
          console.warn('[LCP ATC] Selling plan rejected; retrying LCP as one-time:', err);
          return postCartItems(otpItems).then(afterMainAdd(otpItems));
        }

        /* Combined add rejected (likely the gift line) — keep the sale, drop the gift. */
        if (isOptinSnsOffer() && hasGift && items.length > 1) {
          var mainOnly = items.filter(function (item) {
            return !(item.properties && item.properties._lcp_subscribe_gift === 'true');
          });
          if (!mainOnly.length) throw err;
          console.warn('[LCP ATC] SNS gift line failed; adding main item alone:', err);
          return postCartItems(mainOnly).then(afterMainAdd(mainOnly));
        }

        if (mode !== 'subscription' || !usesLcpB2G2SplitCart() || items.length < 2 || !planError) {
          throw err;
        }

        var snsVariantId = getExternalLcpVariantId(form);
        var activePlanId = getOptinLcpSellingPlanId(form) || getActiveSellingPlanId(getVisibleLcpWrapper(form));
        var fallback = buildSingleSubscriptionItem(snsVariantId, getQty(form), activePlanId);
        if (!fallback || !fallback.length) throw err;
        return postCartItems(fallback).then(afterMainAdd(fallback));
      });
  }

  function buildOptinWmtMainItem(form) {
    var variantInput = form.querySelector(
      '.product-options__size input.js-product-option:checked:not(.js-lcp-pill-option)'
    );
    if (!variantInput) return null;
    var variantId = variantInput.getAttribute('data-variant-id');
    if (!variantId) return null;

    var item = {
      id: parseInt(variantId, 10),
      quantity: getQty(form)
    };

    if (isOptinSubscribed()) {
      /*
        data-sub-plan-id is the cadence-matched plan for this pack, stamped by
        product-options.liquid. Prefer it over the hidden input: the theme's
        variant handler rewrites that input to selling_plan_allocations[0] on
        every change, which is the 6-month plan whenever a product allocates
        both cadences to every variant (sub-v1).
      */
      var planId = variantInput.getAttribute('data-sub-plan-id');
      if (!planId) {
        var planInput = form.querySelector('input[name="selling_plan"]');
        planId = planInput && !planInput.disabled ? planInput.value : null;
      }
      if (planId) item.selling_plan = parseInt(planId, 10);
    }

    return item;
  }

  function runOptinWmtAtc(mainForm, atcBtn) {
    if (lcpAtcInFlight) return;
    var mainItem = buildOptinWmtMainItem(mainForm);
    if (!mainItem) {
      console.error('[LCP ATC] No WMT variant selected for opt-in ATC');
      alert('Could not add to cart. Please select a size and try again.');
      return;
    }

    /* Gift (sub-v3) goes in the same add.js call — one round trip. */
    var items = appendSnsGiftItem([mainItem], mainForm);
    var hasGift = cartHasSnsGift(items);
    /* Overlap the discount pre-read with the add — adds don't change codes. */
    var codesPromise = hasGift ? getCartDiscountCodes() : null;

    lcpAtcInFlight = true;
    setAtcButtonLoading(atcBtn, true);

    /* When a discount update follows, let IT render the cart sections. */
    postCartItems(items, { sections: !hasGift })
      .then(function (data) {
        return maybeApplySnsGiftDiscount(items, data, codesPromise);
      })
      .catch(function (err) {
        /* Plan rejected → no subscription, so retry one-time without the subscribe gift. */
        if (isOptinSubscribed() && isSellingPlanError(err) && mainItem.selling_plan) {
          console.warn('[LCP ATC] WMT selling plan rejected; retrying as one-time:', err);
          delete mainItem.selling_plan;
          return postCartItems([mainItem]);
        }
        /* Combined add rejected (likely the gift line) — keep the sale, drop the gift. */
        if (hasGift) {
          console.warn('[LCP ATC] SNS gift line failed; adding main item alone:', err);
          return postCartItems([mainItem]);
        }
        throw err;
      })
      .then(function (data) {
        return handleCartSuccess(data);
      })
      .catch(function (err) {
        console.error('[LCP ATC]', err);
        alert(err.description || err.message || 'Could not add to cart. Please try again.');
      })
      .finally(function () {
        lcpAtcInFlight = false;
        setAtcButtonLoading(atcBtn, false);
        syncLcpAtcState(mainForm);
      });
  }

  /*
    Only the main buy box and the sticky ATC bar (which mirrors it) go through
    the LCP ATC flow. Other js-product-form instances on the page — quick-view
    modal, cart-drawer upsells — sell their own selection and must keep the
    theme's default ATC.
  */
  function isLcpControlledForm(form, mainForm) {
    if (!form) return false;
    if (form === mainForm) return true;
    return !!form.closest('sticky-bar');
  }

  function bindForms(mainForm) {
    document.querySelectorAll('form.js-product-form').forEach(function (form) {
      if (!isLcpControlledForm(form, mainForm)) return;
      if (form.getAttribute('data-lcp-atc-bound') === 'true') return;
      form.setAttribute('data-lcp-atc-bound', 'true');

      form.addEventListener('submit', function (e) {
        if (isWmtLcpGiftOffer()) {
          e.preventDefault();
          e.stopImmediatePropagation();
          runWmtLcpGiftAtc(mainForm, form.querySelector('.js-wmt-gift-checkout') || form.querySelector('.js-add-to-cart'), true);
          return;
        }

        if (isLcpPdpOfferPage() && !isLcpSelected(mainForm)) {
          e.preventDefault();
          e.stopImmediatePropagation();
          runLcpPdpWmtAtc(mainForm, form.querySelector('.js-add-to-cart'));
          return;
        }

        if (isLcpSelected(mainForm)) {
          e.preventDefault();
          e.stopImmediatePropagation();
          runLcpAtc(mainForm, form.querySelector('.js-add-to-cart'), getDefaultLcpAtcMode());
          return;
        }

        if (isOptinSnsOffer()) {
          e.preventDefault();
          e.stopImmediatePropagation();
          runOptinWmtAtc(mainForm, form.querySelector('.js-add-to-cart'));
          return;
        }

        if (isV3Offer() && isWmtThreePackSelected(mainForm)) {
          e.preventDefault();
          e.stopImmediatePropagation();
          runWmtSplitAtc(mainForm, form.querySelector('.js-add-to-cart'));
        }
      }, true);
    });
  }

  function getFragranceBtnVariantId(wrapper, btn) {
    if (!wrapper || wrapper.getAttribute('data-lcp-v2') !== 'true') {
      return btn.getAttribute('data-variant-id');
    }

    var sns = wrapper.getAttribute('data-lcp-v3') === 'true' || wrapper.getAttribute('data-lcp-sns') !== 'false';
    var attr = sns ? 'data-sns-variant-id' : 'data-otp-variant-id';
    return btn.getAttribute(attr) || btn.getAttribute('data-variant-id');
  }

  function bindLcpSelectionHandlers(mainForm) {
    if (!mainForm || mainForm.getAttribute('data-lcp-selection-bound') === 'true') return;
    mainForm.setAttribute('data-lcp-selection-bound', 'true');

    mainForm.addEventListener('change', function (e) {
      if (
        e.target.classList.contains('js-lcp-pill-option') ||
        e.target.classList.contains('js-product-option') ||
        e.target.name === 'option1'
      ) {
        if (e.target.classList.contains('js-lcp-pill-option') && e.target.checked) {
          mainForm.removeAttribute('data-lcp-external-variant-id');
          var variantId = getExternalLcpVariantId(mainForm);
          if (variantId) {
            mainForm.setAttribute('data-lcp-external-variant-id', variantId);
          }
        } else if (e.target.classList.contains('js-product-option') && !e.target.classList.contains('js-lcp-pill-option')) {
          mainForm.removeAttribute('data-lcp-external-variant-id');
          mainForm.removeAttribute('data-lcp-selling-plan-id');
        }
        var syncDelay = e.target.name === 'option1' ? 120 : 0;
        setTimeout(function () {
          syncLcpAtcState(mainForm);
          if (typeof window.lcpPdpApplyPackState === 'function') window.lcpPdpApplyPackState();
        }, syncDelay);
      }
    });

    mainForm.addEventListener('click', function (e) {
      var fragranceBtn = e.target.closest('.lcp-fragrance-btn');
      var lcpCard = e.target.closest('.lcp-pill-wrapper:not(.lcp-pill-hidden)[data-external-lcp="true"]');

      if (fragranceBtn) {
        var wrapper = fragranceBtn.closest('.lcp-pill-wrapper');
        if (!wrapper) {
          var fragScope = fragranceBtn.closest('.lcp-fragrance-selector');
          var style = fragScope ? fragScope.getAttribute('data-lcp-style') : '';
          wrapper = style
            ? mainForm.querySelector('.lcp-pill-wrapper[data-lcp-style="' + style + '"]:not(.lcp-pill-hidden)')
            : null;
        }
        if (wrapper && mainForm.contains(wrapper)) {
          selectLcpPillRadio(mainForm, wrapper);
          mainForm.setAttribute('data-lcp-external-variant-id', getFragranceBtnVariantId(wrapper, fragranceBtn));
          setTimeout(function () {
            syncLcpAtcState(mainForm);
          }, 0);
        }
        return;
      }

      if (lcpCard && mainForm.contains(lcpCard) && !fragranceBtn) {
        selectLcpPillRadio(mainForm, lcpCard);
        mainForm.removeAttribute('data-lcp-external-variant-id');
        var variantId = getExternalLcpVariantId(mainForm);
        if (variantId) {
          mainForm.setAttribute('data-lcp-external-variant-id', variantId);
        }
        setTimeout(function () {
          syncLcpAtcState(mainForm);
          if (typeof window.lcpPdpApplyPackState === 'function') window.lcpPdpApplyPackState();
        }, 0);
      }
    }, true);

    document.querySelectorAll('form.js-product-form .js-add-to-cart').forEach(function (btn) {
      if (!isLcpControlledForm(btn.closest('form.js-product-form'), mainForm)) return;
      btn.addEventListener('click', function (e) {
        if (isLcpSelected(mainForm)) {
          e.preventDefault();
          e.stopImmediatePropagation();
          runLcpAtc(mainForm, btn, getDefaultLcpAtcMode());
          return;
        }

        if (isLcpPdpOfferPage()) {
          e.preventDefault();
          e.stopImmediatePropagation();
          runLcpPdpWmtAtc(mainForm, btn);
          return;
        }

        if (isOptinSnsOffer()) {
          e.preventDefault();
          e.stopImmediatePropagation();
          runOptinWmtAtc(mainForm, btn);
          return;
        }

        if (isV3Offer() && isWmtThreePackSelected(mainForm)) {
          e.preventDefault();
          e.stopImmediatePropagation();
          runWmtSplitAtc(mainForm, btn);
        }
      }, true);
    });

    document.querySelectorAll('.js-lcp-otp-atc').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        if (isLcpSelected(mainForm)) {
          runLcpAtc(mainForm, null, 'otp');
          return;
        }
        if (isPassiveSubOffer()) {
          runWmtOtpAtc(mainForm);
        }
      });
    });
  }

  function init() {
    var mainForm = getMainForm();
    if (!mainForm) return;

    bindForms(mainForm);
    bindLcpSelectionHandlers(mainForm);
    bindWmtOfferCartCheckout();
    syncLcpAtcState(mainForm);

    window.lcpWmcSyncAtc = function () {
      syncLcpAtcState(mainForm);
    };

    window.lcpWmcRunGiftAtc = function (includeGift, atcBtn) {
      runWmtLcpGiftAtc(mainForm, atcBtn || null, includeGift !== false);
    };

    window.lcpWmcRunAtc = function (mode, atcBtn) {
      if (mode === 'otp') {
        mainForm.removeAttribute('data-lcp-force-otp');
      }
      runLcpAtc(mainForm, atcBtn || null, mode || getDefaultLcpAtcMode());
    };

    window.lcpWmcSyncGallery = function () {
      syncLcpGallery(mainForm);
    };

    setTimeout(function () {
      syncLcpGallery(mainForm);
    }, 1500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
